export default "__VITE_ASSET__ChOx9tue__"